const common = {
  'Common': '일반',

  'Back': '뒤로',
  'Cancel': '취소',

  'Select All': '모두 선택',
  'Select Reverse': '선택 항목 반전',

  'All': '모두',

  'Rare': '레어',
  'Star 3': '★3',
  'Star 4': '★4',
  'Star 5': '★5',
  'Rares': {
    2: '★3',
    3: '★4',
    4: '★5',
  },

  'Class': '클래스',
  'Fighter': '전사',
  'Magician': '마법사',
  'Priest': '승려',
  'Knight': '나이트',
  'Alchemist': '알케미스트',
  'Classes': {
    '-1': '기본',
    0: '전사',
    1: '마법사',
    2: '승려',
    3: '나이트',
    4: '알케미스트',
  },

  'Element': '속성',
  'Fire': '화염',
  'Water': '물',
  'Earth': '흙',
  'Wind': '바람',
  'Moon': '달',
  'Sun': '태양',
  'Elements': {
    '-1': '기본',
    0: '화염',
    1: '물',
    2: '흙',
    3: '바람',
    4: '달',
    5: '태양',
  },

  'Abnormal': '상태이상',
  'Abnormals': {
    'All': '모든 상태이상',
    0: '혼란',
    1: '속박',
    2: '배고픔',
    3: '무기력',
    4: '수면',
    5: '불행',
    6: '침묵',
    7: '고립',
  },

  'Status': '스테이터스',
  'Statuses': {
    'All': '모든 스테이터스',
    0: 'ATK',
    1: 'MAT',
    2: 'DEF',
    3: 'MDF',
    4: 'SPD',
    5: 'LUK',
  },

  'Default': '기본',

  'comma': ', ',
  'dot': '. ',
  'divider': '·',

  'Condition': '조건',
  'Probability': '확률',
  'Filter': '필터',
  'Input': {
    'Filter': '필터를 입력…',
  },
  'Sort': '정렬',
  'Reverse': '역순',
};

const home = {
  'Home': '홈',
  'KiraFan.Moe': 'KiraFan.Moe',
  'KiraFan Wiki': '키라판 해석 위키',
  'Day Count': '키라라 판타지아 출시 {0}일째',

  'Version': 'Version',
  'Version Info': '',

  'Events': '이벤트',
  'Summon': '소환',
  'Summon 10 Times': '10회 소환',
};

const chatacter = {
  'Characters': '캐릭터',
  'Character': '캐릭터',
  'No Character': '캐릭터가 없습니다',
  'Named': '캐릭터',

  'Obtainability': '입수 방법',
  'Normal': '보통',
  'Distributed Weaken': '배포-',
  'Distributed': '배포',
  'Period Limited': '기간 한정',

  'Level': '레벨',
  'Arousal': '각성',
  'Facilities': '시설',
  'Friendship': '친애도',
  'Title Facility': '작품 시설',
  'Class Facility': '클래스 훈련소',
  'Orb': '오브',

  'Illust': '일러스트',
  'Weapons': '무기',
  'Flavor Text': '소환 대사',
  'Creamate Commu Text': '크리에메이트 커뮤 대사',
  'Achievements': '칭호',

  'Related Characters': '관련 캐릭터',
  'Same Rare Class Element': '동일한 {rare} {element} 속성의 {class}들',
  'Same Event': '{event} 이벤트에서 대활약',
  'Same Named': '{name}의 다른 카드',
};

const named = {
  'Names': '캐릭터',
  'Named': '캐릭터',
  'No Named': '캐릭터가 없습니다',

  'Profile': '프로필',
  'Nick Name': '닉네임',
  'Full Name': '풀네임',
  'Gift Type': '선물 유형',
  'Gift Types': {
    1000: '강화 재료',
    2000: '무기 강화 재료',
    3000: '코인',
  },

  'Voice': '보이스',
  'CV': ' CV ',
  'Character Voice Type': {
    0: '시스템',
    1: '시나리오',
    2: '마을',
    3: '배틀',
  },
  'Character Voice Category': {
    '000': '타이틀 콜',
    '001': '실행 시 인사·공통',
    '002': '실행 시 인사·아침',
    '003': '실행 시 인사·밤',
    '006': '강화',
    '008': '진화',
    '009': '트레이닝 출발',
    '010': '트레이닝 완료',
    '012': '미션',
    '013': '미션 완료',

    '400': '퀘스트 출발',
    '401': '배틀 시작 시',
    '403': '가벼운 공격',
    '405': '확실히 공격',
    '406': '공격 스킬',
    '409': '보조 스킬',
    '411': '응원 스킬',
    '412': '톳테오키 발동',
    '413': '대미지',
    '415': '상태이상',
    '416': '전투 불능',
    '417': '배틀 승리',
    '419': '배틀 패배',
    '420': '터치 보이스',

    'Room1': '룸 대화 1',
    'Room2': '룸 대화 2',
    'RoomAction': '룸 액션',
    'Town1': '마을 방문 1',
    'Town2': '마을 방문 2',
    'TownAction': '마을 액션',
    'Home': '홈 화면 대화',

    'Default': '기본',
  },

  'Talent': '탤런트',
  'Adv Standpic': '시나리오 전신 그림',

  'Related Names': '관련 캐릭터',
  'Same Title': '『{title}』의 캐릭터',
  'Same CV': '{name}이(가) 연기한 캐릭터',
  'Cross Adv': '크로스 시나리오에 등장한 동료',

  'Original Character': '오리지널 캐릭터',
  'Illustrator': '일러스트',
};

const skill = {
  'Skills': '스킬',
  'Skill': '스킬',
  'Skill Name': '스킬명',
  'Load': '경직',
  'Recast': '리캐스트',
  'Charge': '차지',
  'Level': '레벨',
  'Stun Gauge': '스턴 게이지',

  'Passive Skill': '자동 발동 스킬',
  'No Skill': '스킬이 없습니다',
  'No Passive Skill': '자동 발동 스킬이 없습니다',

  'Skill Selector': '스킬 선택기',

  'Skill Target': '타깃',
  'Skill Targets': {
    0: '자동',
    1: '적 단일',
    2: '적 전체',
    3: '아군 단일',
    4: '아군 전체',
  },

  'Skill Damage Types': {
    0: '물리',
    1: '마법',
  },

  'Skill Signs': {
    '-1': '다운',
    0: '변화',
    1: '업',
  },

  'Skill Verbs': {
    '-1': '감소',
    0: '변화',
    1: '증가',
  },

  'Skill Turn Types': {
    0: '라운드',
    1: '턴',
  },

  'Skill Type': '스킬 유형',
  'Skill Types': {
    0: '공격',
    1: '회복',
    2: '스테이터스 변화',
    3: '스테이터스 변화 리셋',
    4: '상태이상',
    5: '상태이상 회복',
    6: '상태이상 무효',
    7: '상태이상 부여 확률 보정',
    8: '속성 내성',
    9: '속성 변화',
    10: '유리 속성 보너스',
    11: '다음 공력 위력 업',
    12: '다음 공격 절대 크리티컬',
    13: '배리어',
    14: '리캐스트 변화',
    15: '키라라 점프 게이지양 변화',
    16: '키라라 점프 게이지 배율 변화',
    17: '행동 순서 변화',
    18: '헤이트 변화',
    19: '차지 변화',
    20: '체인 배울 변화',
    21: '스킬 카드',
    22: '스턴 회복',
    23: '부활',
    24: '아무것도 하지 않음',
    25: '스킬 부하 감소',
    26: '크리티컬 대미지양 변화',
    27: '자기 자신 대미지',
    28: '무작위 스테이터스 변화',
    29: '대미지를 받을 때 키라라 점프 게이지양 상승',
    30: '스테이터스 변화 무효',
  },

  'Skill Detail': '설명',
  'Skill Details': {
    0: '{target}에 {damageType} {amount} 대미지 ({power})',
    1: '{target}을(를) {amount} 회복 ({power})',
    2: '{target}의 {status}이(가) {turn}{turnType} {amount} {sign} ({power})',
    3: '{target}의 {status} {sign}을(를) 리셋',
    4: '{target}에 {amount}{abnormal}을(를) 부여 ({power})',
    5: '{target}의 {abnormal}을(를) 해제',
    6: '{target}의 상태이상을 {turn}{turnType} 무효화',
    7: '{target}의 상태이상 저항률이 {turn}{turnType} {sign} ({power})',
    8: '{target}의 {element} 내성이 {turn}{turnType} {amount} {sign} ({power})',
    9: '{target}이(가) {element} 속성이 됨',
    10: '{target}의 유리 속성에 대한 대미지가 {turn}{turnType} 업 ({power})',
    11: '{target}의 {damageType} 공격이 한 번만 {amount} 업 ({power})',
    12: '{target}의 공격이 한 번만 크리티컬이 됨',
    13: '{target}에 {turn}회만 공격을 {amount} ({power}) 차단하는 배리어를 침',
    14: '{target}의 리캐스트를 {amount} {verb} ({power})',
    15: '톳테오키 게이지를 {amount} {verb} ({power})',
    16: '키라라 점프 게이지 배율 변화',
    17: '행동 순서 변화',
    18: '{target}의 노려지기 쉬운 정도가 {turn}{turnType} {amount} {sign} ({power})',
    19: '{target}의 차지 카운트를 {verb} ({power})',
    20: '체인 배율 변화',
    21: '「{extra}」의 스킬 가드를 {turn}개 설치',
    22: '스턴 회복',
    23: '{target}에 {turn}턴의 리커버리를 부여 ({power})',
    24: '아무것도 하지 않음',
    25: '{target}에 {turn}{turnType} 퀵드로를 부여 (-{power}) <small><br>스킬 경직이 다운</small>',
    26: '{target}의 크리티컬 시 대미지가 {turn}{turnType} {amount} {sign} ({power})',
    27: '{target}의 HP가 감소한다 ({power})',
    28: '{target}의 스테이터스 중 몇 개가 {turn}{turnType} {sign}',
    29: '{target}에 {turn}{turnType} 인내를 부여 ({power}) <small><br>대미지를 받을 때마다 톳테오키 게이지가 증가</small>',
    30: '{target}의 스테이터스 다운을 {turn} {turnType} 무효화',
  },

  'Skill Amount': '양',
  'Skill Amount Sign': '{amount} {sign}',
  'Skill Amounts': {
    0: { 0: '특수', 1: '소', 2: '중', '3-': '대', 3: '대', 4: '특대', 5: '초특대' },
    1: { 1: '소', 2: '중', 3: '대', 4: '특대' },
    2: { 1: '소', 2: '중', 3: '대', 4: '특대' },
    4: { 1: '낮은 확률로', 2: '중간 확률로', 3: '높은 확률로', 4: '' },
    8: { 1: '소', 2: '중', 3: '대' },
    11: { 1: '소', 2: '중', 3: '대', 4: '특대' },
    13: { 1: '약간', 2: '', 3: '크게', 4: '완전히' },
    14: { 1: '약간', 2: '', 3: '상당히' },
    15: { 1: '약간', 2: '', 3: '상당히' },
    18: { 1: '소', 2: '중', 3: '대' },
    26: { 1: '소', 2: '중', 3: '대' },
  },

  'Skill Powers': {
    0: {
      0: '{power}%',
      1: '{power}%·상태이상 중인 목표에는 {power2}%',
      2: '{power}% 최대 HP',
      3: '{power}% 현재 HP',
      4: '{power}점',
      5: '{powerA}%·{powerB}%·{powerC}%',
      100: '{power}%·{abnormal} 중인 목표에는 {power2}%',
    },
    27: {
      0: '{power}% 최대 HP',
      1: '{power}% 현재 HP',
      2: '{power}점',
    },
    28: {
      'Power': '{prob}%: {power}',
      'Status Change': '{status} {amount} {sign} ({power})',
    }
  },

  'Passive Triggers': {
    0: '',
    1: '자신이 공격을 받을 때마다',
    2: '자신이 적을 쓰러뜨릴 때마다',
  },
  'Passive Details': {
    0: '자신의 {status}(이)가 {amount} {sign} ({power})',
    1: '자신의 노려지기 쉬운 정도가 {amount} {sign} ({power})',
    2: '자신이 상태이상이 되지 않음',
    3: '자신이 스턴에 걸리지 않음',
    4: '자신의 공격의 스턴 양이 업 ({power})<br><small>공격받은 적의 스턴 게이지 상승량이 업</small>',
    5: '톳테오키 게이지를 {amount} {verb} ({power})',
    6: '자신의 톳테오키 게이지 계수가 {sign} ({power})<br><small>행동에 의한 톳테오키 게이지의 상승량이 변화</small>',
    7: '자신의 크리티컬 시 대미지가 {amount} {sign} ({power})',
    8: '자신의 스킬을 변경',
    9: '자신의 회복 스킬이 최대 HP를 초과 ({power})',
    10: '적에게 입힌 피해에 따라 자신을 회복',
    11: '자신이 리바이브할 수 있음 ({power})<br><small>HP가 0이 될 대미지를 받았을 때 1회만 회복</small>',
    12: '자신의 스킬 가드의 발동 횟수를 {verb} ({power})',
    13: '자신의 HP에 따라 {status}(이)가 변화',
    14: '{target}의 {status}(이)가 {turn}{turnType} {amount} {sign} ({power})',
  },
  'Passive Powers': {
    10: {
      0: '상태이상',
      1: '클래스 스킬',
      2: '무기 스킬',
      3: '톳테오키',
    },
    11: {
      0: '{0}% HP',
      1: '{0}점',
    },
    13: {
      'Status Change': '{status} {amount} {sign} ({power})',
    }
  },
};

const item = {
  'Items': '아이템',
  'Item': '아이템',
  'No Item': '아이템이 없습니다',

  'Type': '유형',
  'Item Type': {
    0: '강화 재료',
    1: '진화 재료',
    2: '한계돌파 재료',
    3: '무기 재료',
    4: '기타',
    10: '이벤트 재료',
  },

  'Category': '카테고리',
  'Item Category Event': '이벤트 「{event}」에 등장하는 아이템',
  'Item Category': {
    0: '작은 씨앗',
    1: '씨앗',
    2: '큰 씨앗',
    3: '새싹',
    4: '콘텐츠 한정 성화',

    100: '소진화주',
    101: '진화주',
    102: '대진화주',
    103: '특대진화주',
    104: '초진화주',
    112: '브론즈 스태추',
    113: '실버 스태추',
    114: '골드 스태추',
    124: '콘텐츠 한정 초진화주',

    202: '꽃봉오리',
    203: '열매',
    204: '성결정',
    214: '콘텐츠 한정 성결정',

    300: '심벌',
    301: '크레스트',
    311: '1장 무기 재료',
    312: '2장 무기 재료',
    313: '3장 무기 재료',
    314: '4장 무기 재료',
    315: '5장 무기 재료',
    316: '6장 무기 재료',
    317: '7장 무기 재료',
    318: '8장 무기 재료',

    404: '특수',
    405: '소환 티켓',
    406: '교환 아이템',
    407: '스태미너 회복 아이템',
    408: '에토와리움',
    409: '찬스 업 키홀더',
    410: '스킬 업 파우더',
  },

  'From Event': '이벤트',
  'Experience': '경험치',
  'Sale Amount': '판매 단가',
};

const weapon = {
  'Weapons': '무기',
  'Weapon': '무기',
  'No Weapon': '무기가 없습니다',

  'Level': '레벨',
  'Evolution': '진화',
  'Upgrade Bonus Material Items': '강화 보너스 재료',
  'Recipe': '제작에 필요한 재료',
  'Evolution Recipe': '진화에 필요한 재료',

  'Equipable Character': '장비할 수 있는 캐릭터',
  'Star 5 Special Weapon': undefined,
};

const master = {
  'Master': '키라라',
  'Stamina': '스태미너',
  'Battle Party Cost': '배틀 코스트',
  'Friend Limit': '프렌드 수',
  'Support Limit': '서포트 수',
  'Weapon Limit': '무기 수',
  'Training Slot Num': '트레이닝 수',
  'Master Skills': '키라라 스킬',
  'Master Orb': '키라라 오브',
  'Master Skill Type': '{class}의 오브',
};

const quest = {
  'Quest Libraries': '퀘스트 라이브러리',
  'Quest Library': '퀘스트 라이브러리',
  'Quests': '퀘스트',
  'Quest': '퀘스트',
  'Section': '{0}절',
  'No Quest': '퀘스트가 없습니다',

  'Quest Library Categories': {
    0: '메인 퀘스트',
    1: '이벤트 퀘스트',
    2: '작가 퀘스트',
    3: '요일 퀘스트',
    4: '챌린지 퀘스트',
    5: '메모리얼 퀘스트',
    6: '크래프트 퀘스트',
  },

  'Event Information': '정보',
  'Event Abstract': '이벤트 개요',
  'Event Bonus': '이벤트 보너스',

  'Enemies': '에너미',
  'Drops': '드롭',

  'User Exp': '키라라 경험치',
  'Character Exp': '캐릭터 경험치',
  'Friendship Exp': '친애도',
};

const scenario = {
  'Scenario Libraries': '시나리오 라이브러리',
  'Scenario Library': '시나리오 라이브러리',
  'Scenarios': '시나리오',
  'Scenario': '시나리오',
  'No Scenario': '시나리오가 없습니다',

  'Scenario Library Categories': {
    5: '캐릭터 시나리오',
    1: '메인 시나리오',
    2: '이벤트 시나리오',
    3: '작가 시나리오',
  },
  'Character Scenario': '캐릭터 시나리오',
  'Cross Scenario': '크로스 시나리오',
  'Memorial Scenario': '메모리얼 시나리오',

  'Standpic': '전신 그림',
  'Pose': '포즈',
  'Face': '얼굴',
};

const title = {
  'Titles': '콘텐츠',
  'Title': '콘텐츠',
  'No Title': '콘텐츠가 없습니다',

  'Number of ★5': '★5 수',
  'Number of Characters': '캐릭터 수',

  'Non-Player Characters': 'NPC 캐릭터',
  'Event Characters': '이벤트 캐릭터',
};

const enemy = {
  'Enemy': '에너미',
  'No Enemy': '에너미가 없습니다',
  'Resist Abnormals': '상태이상 면역',
  'AI ID': 'AI ID',
  'Charge Max': '차지 상한',
  'Full Charge': '풀 차지',
  'Stun Coef': '스턴 계수',

  'AI Conditions': {
    num: '이 조건의 실행 횟수가 {num}회 미만',
    0: '자신의 HP가 {min}%부터 {max}% 범위 안',
    1: {
      0: [
        '에너미에게 {abnormal}인 명수 {op} {num}',
        '에너미에게 {abnormal}이(가) 아닌 명수 {op} {num}',
      ],
      1: [
        '다른 에너미에게 {abnormal}인 명수 {op} {num}',
        '다른 에너미에게 {abnormal}이(가) 아닌 명수 {op} {num}',
      ],
      2: [
        '자신에게 {abnormal}이(가) 존재',
        '자신에게 {abnormal}이(가) 존재하지 않음',
      ],
    },
    2: {
      0: [
        '에너미에게 {statusChange}인 명수 {op} {num}',
        '에너미에게 {statusChange}이(가) 아닌 명수 {op} {num}',
      ],
      1: [
        '다른 에너미에게 {statusChange}인 명수 {op} {num}',
        '다른 에너미에게 {statusChange}이(가) 아닌 명수 {op} {num}',
      ],
      2: [
        '자신에게 {statusChange}이(가) 존재',
        '자신에게 {statusChange}이(가) 존재하지 않음',
      ],
    },
    3: '자신의 차지 카운트 {op} {num}',
    21: '에너미 명수 {op} {num}',
    42: '크리에메이트 명수 {op} {num}',
    43: [
      '크리에메이트에게 {abnormal}인 명수 {op} {num}',
      '크리에메이트에게 {abnormal}이(가) 아닌 명수 {op} {num}',
    ],
    44: '크리에메이트에게 통상 공격 사용 횟수가 {num}에 도달할 때마다',
    45: '크리에메이트에게 스킬 사용 횟수가 {num}에 도달할 때마다',
    46: '크리에메이트에게 톳테오키 사용 횟수가 {num}에 도달할 때마다',
    47: '크리에메이트에게 캐릭터 교체 횟수가 {num}에 도달할 때마다',
    48: '크리에메이트에게 {extra} {class}인 명수 {op} {num}',
    49: '크리에메이트에게 {statusChange}인 명수 {op} {num}',
    68: {
      0: '자신의 스위치 {num}이(가) OFF',
      1: '자신의 스위치 {num}이(가) ON',
    },
  },

  'AI Condition Status Changes': {
    0: 'ATK 업',
    1: 'MAT 업',
    2: 'DEF 업',
    3: 'MDF 업',
    4: 'SPD 업',
    5: 'LUK 업',
    6: 'ATK 다운',
    7: 'MAT 다운',
    8: 'DEF 다운',
    9: 'MDF 다운',
    10: 'SPD 다운',
    11: 'LUK 다운',
    12: '스테이터스 업',
    13: '스테이터스 다운',
  },

  'AI Condition Ops': {
    0: '≥',
    1: '≤',
    2: '=',
  },

  'AI Flags': {
    0: '자신의 스위치 {num}을(를) OFF로 한다',
    1: '자신의 스위치 {num}을(를) ON으로 한다',
  },

  'AI Single Condition': '목표 선택： {target}은(는) 우선도가 {sign} ({power})',
  'AI Single Condition Signs': {
    '-1': '낮음',
    1: '높음',
  },
  'AI Single Conditions': {
    0: 'HP < 20%인 목표',
    1: '{element} 속성인 목표',
    2: '{class}인 목표',
    3: [
      '{abnormal} 있는 목표',
      '{abnormal} 없는 목표',
    ],
    4: '속성 발군인 목표',
    5: '{statusChange} 있는 목표',
    6: '자신',
  },
};

const roomObject = {
  'Room Objects': '가구',
  'Room Object': '가구',

  'Change Night': '나이트 모드 있음',
  'Non-Reverse': '반전 불가',

  'Size': '크기',
  'Buy Amount': '구입 단가',
  'Sell Amount': '판매 단가',
  'Max Num': '최대 소지 수',

  'Search Points': '캐릭터 반응 위치',
  'Search Points Hint': '캐릭터 반응 위치란 캐릭터가 가구 주변에서 액션을 하거나 말할 수 있는 지점을 말합니다.',
  'Character Action': '캐릭터 액션',
  'No Character Action': '캐릭터 액션이 없습니다',
  'Character Tweets': '캐릭터 대사',
  'No Character Tweets': '캐릭터 대사가 없습니다',

  'Room Object Action Conditions': {
    0: '누구나',
    1: '캐릭터 카드 한정',
    2: '캐릭터 한정',
    3: '작품 한정',
  },

  'Room Object Categories': {
    0: '책상',
    1: '의자',
    2: '서랍',
    3: '침구',
    4: '가전',
    5: '잡화',
    6: '취미',
    7: '벽걸이',
    8: '카펫',
    9: '칸막이',
    10: '바닥',
    11: '벽',
    12: '배경',
  },
};

const townObject = {
  'Town Objects': '마을 시설',
  'Town Object': '마을 시설',

  'Schedule': '스케줄',
  'Text': '텍스트',
};

const help = {
  'Page Help': '페이지 도움말',
  'Page Helps': {
    'Room Object': '가구의 데이터를 해석하는 데 협력해 주신 코스케(コースケ) 씨께 감사드립니다. 가구에 대하여 질문이나 조언이 있을 경우에는 사양 말고 연락해 주십시오.',
  },
};

const navigation = {
  'Navigation': '내비게이션',
  'Collection': '콜렉션',

  'Battle': '배틀',
  'Items': '아이템',
  'Library': '라이브러리',
  'Tools': '도구',
  'Links': '링크',
  'Others': '기타',
  'Applications': '키라판 해석 앱',
  'External Links': '외부 링크',

  'Calculator': { Title: '계산기', Subtitle: '수치나 확률을 계산' },
  'Assets': { Title: '에셋 탐색기', Subtitle: '일러스트와 보이스를 다운로드' },
  'Card Maker': { Title: '카드 메이커', Subtitle: '카드 제작 도구' },
  'Yarudesu': { Title: '야루데스! 정보', Subtitle: '키라판 공략 정리' },
  'Wikiwiki': { Title: '키라판 완전공략 위키', Subtitle: '캐릭터 운용 방법·공략 정보·무기 평판 등' },
  'Moegirl': { Title: '모엣코', Subtitle: '중국어 키라판 위키' },
  'Miraheze': { Title: '미라하제', Subtitle: '영어 키라판 위키' },
  'Timers': { Title: '타이머', Subtitle: '이벤트 캘린더와 카운트다운' },
};

const settings = {
  'Settings': '설정',

  'Character Show Max Status': '리스트에서 최대 스테이터스를 표시',
  'Character Show Max Status Hint': '각성 보너스를 가산하지 않습니다',
  'Character Talent Show Luck': '탤런트의 LUK를 표시',
  'Character Icon Framed': '아이콘의 테두리를 표시',
  'Quest Drops Grouped': '드롭을 ‘아이템 수 × 그룹 수’로 표시',
  'App Title Show ID': '앱 제목에 ID를 표시',
  'Enemy AI Pattern': '에너미의 AI 패턴을 표시',
  'Advanced Filter': '고급 필터',
  'Database': '데이터베이스',
  'Database Fetch Time': '데이터베이스 동기화 시간',
  'Hash': 'Hash',
  'Reload Database': '데이터베이스를 다시 불러오기',
  'Reload Application': '앱을 다시 불러오기',
  'Language': '언어',
  'Always Show Japanese': '항상 일본어로 표시',
  'Package Fetch Time': '패키지 동기화 시간',
  'Reload Language Package': '한국어 번역 패키지 다시 불러오기',
  'Help Translate Names': '이름 번역 돕기',

  'Show Clea On Start': undefined,
  'Show Clea On Start Hint': undefined,
  'Show Clea In Detail Page': undefined,
  'Show Clea In Detail Page Hint': undefined,

  'Application': undefined,
  'Contact': undefined,

  'Themes': {
    0: '레드',
    1: '블루',
    2: '오렌지',
    3: '그린',
    4: '퍼플',
    5: '옐로',
    6: '핑크',
    7: '다이내믹',
  },

  'Close': '닫기',
  'Refresh': '다시 불러오기',
  'Updated': {
    'Database': '데이터베이스 업데이트 완료',
    'Application': '앱 업데이트 완료',
  },
};

const clea = {
  'Clea Conversation': {
    'TalkGroupA':
      [
        '元気が出ない時は、声を出すといいですよ。えいえい、おー！',
        'みなさんを召喚するために必要な\n『鍵』の管理を任せていただいています。',
        'ポルカとコルクちゃんは、\nわたしの大切なお友達です。',
        '元気が出ない時は、声を出すといいですよ。\nえいえい、おー！'
      ]
  }
};

module.exports = Object.assign({},
  common, home,
  chatacter, weapon, quest, enemy, master,
  item, roomObject, townObject,
  scenario, title, named,
  skill, help, navigation, settings,
  clea);
